import React from 'react';
import Styles from './styles.js';
import Slider from 'react-slick';
export const RoomSliderOne = props => {
  const { imageSource, spacing } = props;
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className={' slick-arrow right-arrow'} style={{}} onClick={onClick}>
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="28"
          height="28"
          data-ux="Icon"
          data-edit-interactive="true"
          className="x-el x-el-svg ">
          <path
            fillRule="evenodd"
            d="M7.236 4.195a.773.773 0 0 1
           1.06.031l7.743 7.883-7.742 7.42a.773.773
            0 0 1-1.06 0 .697.697 0 0 1
             0-1.017l6.712-6.433-6.745-6.868a.697.697 0
              0 1 .032-1.016"></path>
        </svg>
      </div>
    );
  }
  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className={' slick-arrow left-arrow'} onClick={onClick}>
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="28"
          height="28"
          data-ux="Icon"
          data-edit-interactive="true"
          className="x-el x-el-svg  ">
          <path
            fillRule="evenodd"
            d="M15.804 19.544a.774.774 0 0 1-1.061-.03L7
           11.63l7.742-7.42a.773.773 0 0 1 1.061 0
            .697.697 0 0 1 0 1.017L9.09 11.66l6.745
             6.867a.698.698 0 0 1-.031 1.016"></path>
        </svg>
      </div>
    );
  }
  var settings = {
    className: 'roomSliderOne',
    dots: true,
    infinite: true,
    slidesToShow: 4,
    speed: 500,
    slidesToScroll: 3,
    arrows: false,
    autoplay: true,
    cssEase: 'scroll',
    nextArrow: <SampleNextArrow className="slick-arrow right-arrow" />,
    prevArrow: <SamplePrevArrow className="slick-arrow left-arrow" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div>
      <div className="container-fluid p-0">
        <div className="">
          <Slider {...settings}>
            {imageSource.map((Item, index) => (
              <div key={index}>
                <img
                  loading="lazy"
                  className={spacing ? 'd-block px-custom  img img-fluid px-0' : 'block px-custom  img img-fluid '}
                  src={Item.src}
                  alt="First slide"
                />
                {Item.title ? <p className="imgText md:pl-12 pl-4">{Item.title} </p> : null}
              </div>
            ))}
          </Slider>
        </div>
      </div>
      <Styles/>
    </div>
  );
};
export default RoomSliderOne;
